export default "__VITE_ASSET__BD9$_Huz__"